import { Box, IconButton, Typography, Snackbar, SnackbarContent, Portal } from '@mui/material';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';

function SnackbarAlert({ open, handleClose, message }) {
  return (
    <Portal>
    <Snackbar
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2000 }}
      open={open}
      onClose={handleClose}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      container={document.body}
    >
      <SnackbarContent
        sx={{
          backgroundColor: '#fff',
          minWidth: 360,
          p: 2,
          boxShadow: 3,
          borderRadius: 1,
          borderLeft: `4px solid ${message.type === 'error' ? '#d32f2f' : '#00b33c'}`
        }}
        message={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {message.type === 'success' ? (
              <CheckCircleIcon sx={{ mr: 2, fontSize: 28, color: 'success.dark' }} />
            ) : (
              <ErrorOutlineIcon sx={{ mr: 2, fontSize: 28, color: 'error.main' }} />
            )}

            {/* Center text */}
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight="bold" color={message.type === 'error' ? 'error.dark' : 'success.dark'}>
                {message.title}
              </Typography>
              <Typography variant="subtitle2" color="text.primary">
                {message.content}
              </Typography>
            </Box>

            {/* Right close button */}
            <IconButton
              size="small"
              onClick={handleClose}
              sx={{
                ml: 2,
                color: 'text.secondary'
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        }
      />
    </Snackbar>
    </Portal>
  );
}

export default SnackbarAlert;
